
export enum PendoEventTypes {
    HomePatientBegin = 'HomePatientBegin',
    HomeProviderBegin = 'HomeProviderBegin',
    PatientEnrollmentStart = 'PatientEnrollmentStart',
    ProviderEnrollmentStart = 'ProviderEnrollmentStart',
    PatientEnrollmentStop = 'PatientEnrollmentStop',
    ProviderEnrollmentStop = 'ProviderEnrollmentStop',
    HcpEligibilityCheck = 'HcpEligibilityCheck',
    HcpPrescriberLookUp = 'HcpPrescriberLookUp',
    HcpPrescriberDetails = 'HcpPrescriberDetails',
    HcpFacilityPreferences = 'HcpFacilityPreferences',
    HcpFacilityResultsCard = 'HcpFacilityResultsCard',
    HcpFacilityResultsTable = 'HcpFacilityResultsTable',
    HcpFacilitySearch = 'HcpFacilitySearch',
    HcpPostFacilitySearch = 'HcpPostFacilitySearch',
    HcpPatientInformation = 'HcpPatientInformation',
    HcpPatientInsurance = 'HcpPatientInsurance',
    HcpPatientMedicalHistory = 'HcpPatientMedicalHistory',
    HcpPharmacyPreference = 'HcpPharmacyPreference',
    HcpPharmacy = 'HcpPharmacy',
    HcpAddPharmacy = 'HcpAddPharmacy',
    HcpPharmacyResultsCard = 'HcpPharmacyResultsCard',
    HcpPharmacyResultsTable = 'HcpPharmacyResultsTable',
    HcpPharmacySearch = 'HcpPharmacySearch',
    HcpProductDetails = 'HcpProductDetails',
    HcpPrescriptionDetails = 'HcpPrescriptionDetails',
    HcpReview = 'HcpReview',
    HcpAttestation = 'HcpAttestation',
    HcpAttestationSubmit = 'HcpAttestationSubmit',
    HcpAttestationSubmitSuccess = 'HcpAttestationSubmitSuccess',
    HcpAttestationSubmitFailure = 'HcpAttestationSubmitFailure',
    HcpDownloadDocument = 'HcpDownloadDocument',
    HcpUploadDocument = 'HcpUploadDocument',

    PtEligibilityCheck = 'PtEligibilityCheck',
    PtPrescriberLookUp = 'PtPrescriberLookUp',
    PtPrescriberDetails = 'PtPrescriberDetails',
    PtFacilityPreferences = 'PtFacilityPreferences',
    PtFacilityResultsCard = 'PtFacilityResultsCard',
    PtFacilityResultsTable = 'PtFacilityResultsTable',
    PtFacilitySearch = 'PtFacilitySearch',
    PtPostFacilitySearch = 'PtPostFacilitySearch',
    PtPatientInformation = 'PtPatientInformation',
    PtPatientInsurance = 'PtPatientInsurance',
    PtPatientMedicalHistory = 'PtPatientMedicalHistory',
    PtPharmacyPreference = 'PtPharmacyPreference',
    PtPharmacy = 'PtPharmacy',
    PtAddPharmacy = 'PtAddPharmacy',
    PtPharmacyResultsCard = 'PtPharmacyResultsCard',
    PtPharmacyResultsTable = 'PtPharmacyResultsTable',
    PtPharmacySearch = 'PtPharmacySearch',
    PtProductDetails = 'PtProductDetails',
    PtPrescriptionDetails = 'PtPrescriptionDetails',
    PtReview = 'PtReview',
    PtAttestation = 'PtAttestation',
    PtAttestationSubmit = 'PtAttestationSubmit',
    PtAttestationSubmitSuccess = 'PtAttestationSubmitSuccess',
    PtAttestationSubmitFailure = 'PtAttestationSubmitFailure',
    PtDownloadDocument = 'PtDownloadDocument',
    PtUploadDocument = 'PtUploadDocument',
}
